module.exports = require("./kea.d.ts");